/**
 * The controlled terminology release the platform pins by default. Must equal
 * functions/src/sdtm/fdaDataStandardsCatalog.ts CURRENT_CT_VERSION; a functions test
 * (sdtm/submission/specificationPackageRound2.test.ts, section 4) fails when the two differ. web cannot import functions code.
 */
export const CURRENT_CT_VERSION = '2026-03-27';
